import { useEffect, useState } from "react";
import { api } from "../lib/api";
import TextList from "../components/TextList";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (!q.trim()) {
        setResults([]);
        setSearched(false);
        return;
      }
      setLoading(true);
      try {
        const { data } = await api.get("/texts", { params: { q: q.trim(), limit: 100 } });
        setResults(data);
        setSearched(true);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div
      className="max-w-4xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-32"
      data-testid="search-page"
    >
      <div
        className="text-xs uppercase tracking-[0.35em] mb-6"
        style={{ color: "var(--rincon-secondary)" }}
      >
        Buscar en el cuaderno
      </div>
      <h1
        className="font-display text-5xl md:text-6xl tracking-tight"
        style={{ color: "var(--rincon-text)" }}
      >
        ¿Qué palabra buscas?
      </h1>

      <div
        className="mt-12 flex items-center gap-4 border-b pb-3"
        style={{ borderColor: "var(--rincon-text)" }}
      >
        <SearchIcon className="w-5 h-5" style={{ color: "var(--rincon-text-muted)" }} />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Un verso, un título, una etiqueta..."
          autoFocus
          data-testid="search-input"
          className="flex-1 bg-transparent outline-none font-display text-2xl md:text-3xl placeholder:italic"
          style={{ color: "var(--rincon-text)" }}
        />
      </div>

      <div className="mt-14">
        {loading ? (
          <div
            className="py-16 text-center font-display italic text-xl"
            style={{ color: "var(--rincon-text-muted)" }}
          >
            Buscando...
          </div>
        ) : searched ? (
          <>
            <div
              className="text-sm italic mb-8"
              style={{ color: "var(--rincon-text-muted)" }}
              data-testid="search-count"
            >
              {results.length} {results.length === 1 ? "resultado" : "resultados"} para «{q}»
            </div>
            <TextList texts={results} emptyMessage="Ninguna palabra coincide con tu búsqueda." />
          </>
        ) : (
          <div
            className="py-10 font-body italic"
            style={{ color: "var(--rincon-text-muted)" }}
          >
            Escribe para empezar a buscar.
          </div>
        )}
      </div>
    </div>
  );
}
